'use client'

/***
 *
 * @file client/foundations/LoadScript/index.tsx
 * @description LoadScript client component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Truminds Software System
 * @since 13 Feb 2024
 *
 */

import { useEffect, useState } from "react";
// import "./LoadScript.scss";
import { Router } from "next/router";
import { GoogleTagManager } from "@next/third-parties/google";
import { MARKETING_COOKIE_ID, PERFORMANCE_COOKIE_ID } from "@/config/app.config";

type Props = {
  gtmId?: string;
  gaId?: string;
}

const LoadScript = ({ gtmId = "", gaId = "" }: Props) => {
  const [enableScripts, setEnableScripts] = useState(false);
  // const [cookieConsent, setCookieConsent] = useState(false);

  // const updateConsent = () => {
  //   if (window?.OptanonActiveGroups?.includes(PERFORMANCE_COOKIE_ID) || window?.OptanonActiveGroups?.includes(MARKETING_COOKIE_ID)) {
  //     setCookieConsent(true)
  //   }
  //   else {
  //     setCookieConsent(false)
  //   }
  // }

  useEffect(() => {
    "use strict";
    setEnableScripts(false);
    Router.events.on("routeChangeComplete", (path) => {
      console.log(`Route change complete.`);
      setTimeout(() => {
        setEnableScripts(true)
      }, 2000);
    });

    return () => {
      Router.events.off('routeChangeComplete', () => { });
    }
  }, [Router]);

  useEffect(() => {
    // window.document.readyState === "complete" && setEnableScripts(true)
    setTimeout(() => {
      setEnableScripts(true)
    }, 2000);

    // window?.Optanon?.OnConsentChanged(updateConsent);

    // return (()=>{
    //   window?.Optanon?.OnConsentChanged(null);
    // })
  }, [])


  return (
    enableScripts &&
    <>
      {gtmId && <GoogleTagManager gtmId={gtmId} />}

      {/* Google Analytics */}
      {/* {gaId && <GoogleAnalytics gaId={gaId} />} */}
    </>
  );
};

export default LoadScript;
